module.exports = __webpack_public_path__ + "static/floorplan3-8c22446a52a5b1a863ff57037b0b90e3.png";